<div [@routerTransition]>
    <sub-header
        [title]="('Vendors' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"
    ></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <tabset>
                    <tab heading="{{ 'BasicInformation' | localize }}">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Vendor_VendorCode">{{ l('VendorCode') }} *</label>
                                    <input
                                        type="text"
                                        #Vendor_VendorCode="ngModel"
                                        id="Vendor_VendorCode"
                                        class="form-control"
                                        [(ngModel)]="vendor.vendorCode"
                                        name="VendorCode"
                                        minlength="0"
                                        maxlength="50"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Vendor_VendorCode"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Vendor_Name">{{ l('Name') }} *</label>
                                    <input
                                        type="text"
                                        #Vendor_Name="ngModel"
                                        id="Vendor_Name"
                                        class="form-control"
                                        [(ngModel)]="vendor.name"
                                        name="Name"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Vendor_Name"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="Vendor_Email">{{ l('Email') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_Email="ngModel"
                                        id="Vendor_Email"
                                        class="form-control"
                                        [(ngModel)]="vendor.email"
                                        name="Email"
                                    />
                                    <validation-messages [formCtrl]="Vendor_Email"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="Vendor_PurchaseLimit">
                                        {{ l('PurchaseLimit') }}
                                    </label>
                                    <input
                                        type="number"
                                        #Vendor_PurchaseLimit="ngModel"
                                        id="Vendor_PurchaseLimit"
                                        class="form-control"
                                        [(ngModel)]="vendor.purchaseLimit"
                                        name="PurchaseLimit"
                                    />
                                    <validation-messages [formCtrl]="Vendor_PurchaseLimit"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="Vendor_DiscountPerc">{{ l('DiscountPerc') }}</label>
                                    <input
                                        type="number"
                                        #Vendor_DiscountPerc="ngModel"
                                        id="Vendor_DiscountPerc"
                                        class="form-control"
                                        [(ngModel)]="vendor.discountPerc"
                                        name="DiscountPerc"
                                    />
                                    <validation-messages [formCtrl]="Vendor_DiscountPerc"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_TaxRegistrationNo">{{ l('TaxRegistrationNo') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_TaxRegistrationNo="ngModel"
                                        id="Vendor_TaxRegistrationNo"
                                        class="form-control"
                                        [(ngModel)]="vendor.taxRegistrationNo"
                                        name="TaxRegistrationNo"
                                    />
                                    <validation-messages [formCtrl]="Vendor_TaxRegistrationNo"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <br />
                                <br />
                                <label class="form-check form-check-custom form-check-solid">
                                    <input
                                        id="Vendor_IsTaxExempt"
                                        #Vendor_IsTaxExempt="ngModel"
                                        name="IsTaxExempt"
                                        [(ngModel)]="vendor.isTaxExempt"
                                        type="checkbox"
                                        class="form-check-input"
                                    />
                                    <span class="form-check-label">
                                        {{ l('IsTaxExempt') }}
                                    </span>
                                </label>
                                <validation-messages [formCtrl]="Vendor_IsTaxExempt"></validation-messages>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_Attention">{{ l('Attention') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_Attention="ngModel"
                                        id="Vendor_Attention"
                                        class="form-control"
                                        [(ngModel)]="vendor.attention"
                                        name="Attention"
                                    />
                                    <validation-messages [formCtrl]="Vendor_Attention"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_AttentionPhoneNo">{{ l('AttentionPhoneNo') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_AttentionPhoneNo="ngModel"
                                        id="Vendor_AttentionPhoneNo"
                                        class="form-control"
                                        [(ngModel)]="vendor.attentionPhoneNo"
                                        name="AttentionPhoneNo"
                                        minlength="0"
                                        maxlength="30"
                                    />
                                    <validation-messages [formCtrl]="Vendor_AttentionPhoneNo"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label for="PaymentTermName">{{ l('PaymentTerm') }}</label>
                                    <select
                                        name="vendor.paymentTermId"
                                        [(ngModel)]="vendor.paymentTermId"
                                        class="form-select"
                                    >
                                        <option value="">{{ l('SelectAPaymentTerm') }}</option>

                                        <option *ngFor="let item of allPaymentTerms" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label for="CurrencyName">{{ l('Currency') }}</label>
                                    <select
                                        name="vendor.currencyId"
                                        [(ngModel)]="vendor.currencyId"
                                        class="form-select"
                                    >
                                        <option value="">{{ l('SelectACurrency') }}</option>

                                        <option *ngFor="let item of allCurrencys" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label for="LocationName">{{ l('Location') }}</label>
                                    <select
                                        name="vendor.locationId"
                                        [(ngModel)]="vendor.locationId"
                                        class="form-select"
                                    >
                                        <option value="">{{ l('SelectALocation') }}</option>

                                        <option *ngFor="let item of allLocations" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label for="ChartOfAccountDisplayProperty">{{ l('ChartOfAccount') }}</label>
                                    <select name="vendor.accountId" [(ngModel)]="vendor.accountId" class="form-select">
                                        <option value="">{{ l('SelectAChartOfAccount') }}</option>

                                        <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Address' | localize }}">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_Address1">{{ l('Address1') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_Address1="ngModel"
                                        id="Vendor_Address1"
                                        class="form-control"
                                        [(ngModel)]="vendor.address1"
                                        name="Address1"
                                    />
                                    <validation-messages [formCtrl]="Vendor_Address1"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_Address2">{{ l('Address2') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_Address2="ngModel"
                                        id="Vendor_Address2"
                                        class="form-control"
                                        [(ngModel)]="vendor.address2"
                                        name="Address2"
                                    />
                                    <validation-messages [formCtrl]="Vendor_Address2"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_Address3">{{ l('Address3') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_Address3="ngModel"
                                        id="Vendor_Address3"
                                        class="form-control"
                                        [(ngModel)]="vendor.address3"
                                        name="Address3"
                                    />
                                    <validation-messages [formCtrl]="Vendor_Address3"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_City">{{ l('City') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_City="ngModel"
                                        id="Vendor_City"
                                        class="form-control"
                                        [(ngModel)]="vendor.city"
                                        name="City"
                                    />
                                    <validation-messages [formCtrl]="Vendor_City"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_State">{{ l('State') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_State="ngModel"
                                        id="Vendor_State"
                                        class="form-control"
                                        [(ngModel)]="vendor.state"
                                        name="State"
                                    />
                                    <validation-messages [formCtrl]="Vendor_State"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_Country">{{ l('Country') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_Country="ngModel"
                                        id="Vendor_Country"
                                        class="form-control"
                                        [(ngModel)]="vendor.country"
                                        name="Country"
                                    />
                                    <validation-messages [formCtrl]="Vendor_Country"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_PostalCode">{{ l('PostalCode') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_PostalCode="ngModel"
                                        id="Vendor_PostalCode"
                                        class="form-control"
                                        [(ngModel)]="vendor.postalCode"
                                        name="PostalCode"
                                    />
                                    <validation-messages [formCtrl]="Vendor_PostalCode"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_PhoneNo">{{ l('PhoneNo') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_PhoneNo="ngModel"
                                        id="Vendor_PhoneNo"
                                        class="form-control"
                                        [(ngModel)]="vendor.phoneNo"
                                        name="PhoneNo"
                                    />
                                    <validation-messages [formCtrl]="Vendor_PhoneNo"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Vendor_FaxNo">{{ l('FaxNo') }}</label>
                                    <input
                                        type="text"
                                        #Vendor_FaxNo="ngModel"
                                        id="Vendor_FaxNo"
                                        class="form-control"
                                        [(ngModel)]="vendor.faxNo"
                                        name="FaxNo"
                                    />
                                    <validation-messages [formCtrl]="Vendor_FaxNo"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabset>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button
                        (click)="save()"
                        class="btn btn-primary blue me-2"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>

                    <button
                        *ngIf="!this.vendor.id"
                        (click)="saveAndNew()"
                        class="btn btn-primary blue float-right"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAndNew') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
